<template>

    <div class="feedback">
        <a class="fb-item" @click="value3 = true">
            <img src="@/assets/images/chat.png" alt="蒙文翻译">
            <p >{{$t("feedback")}}</p>
        </a>
        <Drawer :title="$t('feedback')" placement="right" :closable="false" v-model="value3">
            <div class="_center">
                <div class="_title">
                    <img src="@/assets/images/wechat_icon.png" alt="蒙古语语音合成">
                    <h3>{{$t("technicalServices")}}{{$t("weChatGroup")}}</h3>
                </div>
                <div class="fb-img">
                    <img src="https://onon-guanwang.oss-cn-beijing.aliyuncs.com/wcg/wcg.png" alt="蒙古语语音合成">
                </div>
                <p class="hint">（微信扫一扫加入）</p>
            </div>
            <br>
            <br>
            <div class="_center">
                <div class="_title">
                    <img src="@/assets/images/chat.png" alt="蒙古语语音合成">
                    <h3>{{$t("feedback")}}</h3>
                </div>
                
                <a class="fb-link" href="https://wj.qq.com/s2/14682602/3919/" target="_blank">
                    {{$t("feedback")}}
                </a>
                <p class="hint">（请点击链接进行反馈）</p>
            </div>

        </Drawer>
    </div>
</template>

<script>
export default {
    name: 'FeedBack',
    data () {
        return {
            value1: false,
            value2: false,
            value3: false
        }
    }
}
</script>

<style>
.fb-hr {
    width: 20px;
    margin: 10px auto;
    border: 0;
    border-top: 1px solid rgba(0, 0, 0, .1);
}
.feedback {
    position: fixed;
    z-index: 99;
    right: 8px;
    bottom: 210px;
    border-radius: 10px;
    box-shadow: 0px 0px 4px 2px #00000017;
    padding: 12px 2px;
    background-color: #4d425f;
    color: #fff;
    font-size: 14px;
}

.feedback .fb-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 40px;
}

.feedback img {
    width: 32px;
    height: 32px;
}

.fb-img {
    margin-top: 4px;
    width: 160px;
}

.fb-img img {
    width: 100%;
}

.fb-link {
    width: 160px;
    height: 160px;
    margin-top: 4px;
    background-color: #fff;
    background-image: url("@/assets/images/pc_bolang.png");
    background-position: center;
    background-size: 80%;
    background-repeat: no-repeat;
    line-height: 160px;
    color: #fff;
}
._title {
    display: flex;
}
._title h3 {
    line-height: 32px;
    margin-left: 12px;
}
._title img {
    width: 32px;
    height: 32px;
}

._center {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.fb-item p {
    font-size: 14px;
    text-align: center;
    margin-bottom: 0;
    line-height: 12px;
    writing-mode: tb;
    margin-top: 4px;
    color: #fff;
}

.feedback a {
    text-decoration: none;
    color: initial;
}

.ivu-drawer-header,.ivu-drawer-body {
 background-color: #4d425f;
 color: #fff;
}

 .ivu-drawer-header {
    border-bottom: 1px solid var(--header-theme-color) !important;
}
.ivu-drawer-header-inner {
 color: #fff !important;

}

@media screen and (max-width: 768.98px) {
    .feedback {
        display: none;
    }
}

</style>